import Number from 'helpers/Number';
import get from 'lodash/get';
import { action } from 'mobx';
import BigNumbersFormat from 'modules/userManager/usersList/bigNumbers/BigNumbersFormat';

import DashboardStore from './DashboardStore';
import { getMembersAreaPostUrl } from './helpers';

import Request, { axios } from '@hotmart/request';

class DashboardService {
  @action
  fetchUserData = () => {
    this.setUserData({
      loading: true
    });

    Request('dashboard.users.information')
      .then((response) => {
        const avgProgress = `${BigNumbersFormat.formatPercentage(
          get(response, 'avgProgress.value', 0)
        )}%`;
        const avgEngagement = get(response, 'avgEngagement.value', 0);
        const areaTotalUsers = Number.format(
          get(response, 'areaTotalUsers.value', 0)
        );
        const percentTotalUsers = `${BigNumbersFormat.formatPercentage(
          get(response, 'areaTotalUsers.searchPercentage', 0)
        )}`;
        const conclusionPercentage = `${BigNumbersFormat.formatPercentage(
          get(response, 'conclusionPercentage.value', 0)
        )}%`;

        this.setUserData({
          avgProgress,
          avgEngagement,
          areaTotalUsers,
          percentTotalUsers,
          conclusionPercentage,
          loading: false,
          error: false
        });
      })
      .catch(() => {
        this.setUserData({
          loading: false,
          error: true
        });
      });
  };

  fetchMembersAreaPost = async (shortLocale) => {
    const url = getMembersAreaPostUrl(shortLocale);
    const response = await axios.get(url);

    if (!response || !response.data) {
      throw '';
    }

    const link = get(response, 'data.link', '');
    const title = get(response, 'data.title.rendered', '');
    const description = get(response, 'data.meta._yoast_wpseo_metadesc', '');
    const mediaUrl = get(response, 'data._links.wp:featuredmedia.[0].href', '');

    let imageSrc = '';

    if (mediaUrl) {
      const mediaResponse = await axios.get(mediaUrl);

      if (!mediaResponse || !mediaResponse.data) {
        throw '';
      }

      imageSrc = get(
        mediaResponse,
        'data.media_details.sizes.profile_300.source_url',
        ''
      );
    }

    return {
      title,
      description,
      link,
      imageSrc
    };
  };

  hasNewClub = async (productId) => {
    try {
      const response = await Request('has.newClub', { productId });

      return response;
      // eslint-disable-next-line no-empty
    } catch {}
  };

  getEligibleProducts = async () => {
    const response = await Request('eligible.products');

    return response;
  };

  @action
  setData(data) {
    Object.assign(DashboardStore, { ...data });
  }

  @action
  setUserData(data) {
    this.setData({
      user: {
        ...DashboardStore.user,
        ...data
      }
    });
  }
}

export default new DashboardService();
